export default __webpack_public_path__ + "static/media/Line.da14ff93.svg";